import type { ReferentialAssetState } from "@/entities/referential/referential-states-asset/referential-states-asset.type";

import { useReferentialStates } from "@/entities/referential/referential-states/referential-states.query";

import { REFERENTIAl_STATES_ENDPOINTS } from "../referential-states/referential-states.enum";

export const useReferentialAssetStates = () => {
  return useReferentialStates<ReferentialAssetState>(
    REFERENTIAl_STATES_ENDPOINTS.ASSET
  );
};
